import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const RoomsAreaDetailed = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    date: null,
    rooms: null,
    area: null
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})
    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    if (field[1] === 'date') {
      let dateModeCheck = checkDateSet(val, items)
      setHomogenous(dateModeCheck.homogenous)
      _.set(newData, 'dateMode', dateModeCheck.dateMode)
    }
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    setData(newData)
    props.persist({items: newData.items, dateMode: newData.dateMode, state: 'detailed'}, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date");
    _.set(newData, 'items', strippedItems);
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed');
    props.persist({items: newData.items, dateMode: newData.dateMode, state: 'detailed'}, 'roomdetail', props.rowData);
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (props['rowData']['roomdetail']?.state !== 'detailed'){
      setItems([{...emptyRecord, i: 0}]);
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('room', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row rooms-area-detailed">
            <div>
              { i === 0 && <label>Date</label> }
              <DateInput className="automated" attrs={attrs} field={[`${row['i']}`, 'date']} {...params} allowRelative withoutDays />
            </div>
            <div>
              { i === 0 && <label>Rooms</label> }
              <NumberInput className="automated" attrs={attrs} field={[`${row['i']}`, 'rooms']} {...params} min={1} max={100000} readPrecision={2} writePrecision={2} />
            </div>  
            <div>
              { i === 0 && <label>Area</label> }
              <NumberInput className="automated" attrs={attrs} field={[`${row['i']}`, 'area']} {...params} min={1} max={100000} readPrecision={2} writePrecision={2} />
            </div>
            <RowAddRemove emptyRecord={emptyRecord} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default RoomsAreaDetailed
